import { render, staticRenderFns } from "./OrganizationApplication.vue?vue&type=template&id=19440cd2&scoped=true"
import script from "./OrganizationApplication.vue?vue&type=script&lang=js"
export * from "./OrganizationApplication.vue?vue&type=script&lang=js"
import style0 from "./OrganizationApplication.vue?vue&type=style&index=0&id=19440cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19440cd2",
  null
  
)

export default component.exports